import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const CoreLayout = ({ children }) => {
  return <div className="layout">{children}</div>;
};

CoreLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ])
};

export default CoreLayout;
